import { IgnoreZone } from "../../pages/Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { isPointInNormalizedPolygon } from "./isPointInNormalizedPolygon";
import { normalizeZonePolygons } from "./normalizeZonePolygons";

/**
 * Returns label_display_name for every zone whose polygon(s) contain the point.
 * Point is in normalized image coordinates [0, 1].
 */
export const getIgnoreZoneLabelsAtPoint = (
  point: [number, number],
  zones: IgnoreZone[]
): string[] => {
  const labels: string[] = [];

  for (const zone of zones) {
    const polygons = normalizeZonePolygons(zone.coordinates);
    const isInside = polygons.some((polygon) =>
      isPointInNormalizedPolygon(polygon, point)
    );
    if (isInside && zone.label_display_name) {
      labels.push(zone.label_display_name);
    }
  }

  return labels;
};
